const HAULS = [
  {
    img: "https://images.unsplash.com/photo-1785102742384-123dd05c1465?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNTl8MHwxfHNlYXJjaHwzfHxlbXB0eSUyMGNsZWFuJTIwZ2FyYWdlJTIwZmxvb3J8ZW58MHx8fHwxNzkwMDgyMzU0fDA&ixlib=rb-4.1.0&q=85",
    loc: "Palm Bay, FL",
    title: "Full Garage Clearing",
    desc: "2-car packed garage hauled & swept in under 2 hours.",
  },
  {
    img: "https://images.unsplash.com/photo-1577412647305-991150c7d163?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwxfHxlbXB0eSUyMG9mZmljZSUyMHNwYWNlJTIwY2xlYW58ZW58MHx8fHwxNzkwMDgyMzU0fDA&ixlib=rb-4.1.0&q=85",
    loc: "Melbourne, FL",
    title: "Office Turnover",
    desc: "Commercial furniture deconstruction and haul-away.",
  },
  {
    img: "https://images.unsplash.com/photo-1765700937202-8249d0db775d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHwzfHx5YXJkJTIwZGVicmlzJTIwYnJhbmNoJTIwcGlsZXxlbnwwfHx8fDE3OTAwODIzNTR8MA&ixlib=rb-4.1.0&q=85",
    loc: "Viera, FL",
    title: "Yard Debris Haul",
    desc: "Felled branches and fencing cleared post-storm.",
  },
  {
    img: "https://images.unsplash.com/photo-1781425009053-2baffa997d8c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzN8MHwxfHNlYXJjaHwyfHxsb2FkZWQlMjBwaWNrdXAlMjB0cnVjayUyMGdhcmJhZ2V8ZW58MHx8fHwxNzkwMDgyMzU0fDA&ixlib=rb-4.1.0&q=85",
    loc: "Cocoa, FL",
    title: "Full Truckload Dispatch",
    desc: "Heavy appliance and construction debris haul.",
  },
];

export default function Gallery() {
  return (
    <section id="gallery" data-testid="gallery-section" className="py-24 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto">
      <div className="flex flex-col md:flex-row md:items-end justify-between mb-16 gap-6 border-b border-white/10 pb-8">
        <div>
          <h2 className="text-3xl sm:text-5xl font-black uppercase tracking-tighter font-display text-white">
            Recent Brevard Cleanouts
          </h2>
          <p className="text-zinc-400 text-sm sm:text-base mt-2 max-w-xl">
            Real hauls from Palm Bay, Melbourne, and across the Space Coast. Loaded out, swept down, and cleared.
          </p>
        </div>
        <span className="text-xs font-mono text-zinc-400 uppercase tracking-widest">Job Site Records</span>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {HAULS.map((h) => (
          <div
            key={h.title}
            data-testid={`gallery-card-${h.loc.split(",")[0].toLowerCase()}`}
            className="group relative rounded-2xl border border-zinc-800 overflow-hidden bg-zinc-950 aspect-[4/5]"
          >
            <img
              src={h.img}
              alt={`${h.title} — ${h.loc}`}
              loading="lazy"
              className="absolute inset-0 w-full h-full object-cover opacity-80 group-hover:opacity-100 group-hover:scale-105 transition-all duration-500"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black via-black/40 to-black/20" />
            <div className="relative w-full h-full p-6 flex flex-col justify-between">
              <span className="text-[10px] font-mono uppercase tracking-widest text-zinc-300 bg-black/80 px-2.5 py-1 rounded w-fit border border-zinc-700">
                {h.loc}
              </span>
              <div>
                <h4 className="text-base font-black uppercase text-white">{h.title}</h4>
                <p className="text-xs text-zinc-400 mt-1">{h.desc}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
